import { call, put } from 'redux-saga/effects';
import { push } from 'connected-react-router';
import { Creators as MessagesCreators } from '../ducks/messages';
import { Creators as ResetPasswordCreators } from '../ducks/resetPassword';
import { Creators as SessionCreators } from '../ducks/session';
import api from '../../services/api';
import { formatter } from '../../services/apiResponseFormatter';
import { IS_APP } from '../../services/target';

export function* checkToken(action) {
  const response = yield call(api.get, `v1/customers/password/${action.payload.token}`);

  if (response.ok) {
    yield put(ResetPasswordCreators.tokenSuccess());
  } else {
    yield put(MessagesCreators.setMessage(
      'Link de troca de senha inválido ou expirado. Tente novamente.',
      'warning',
      true,
    ));
    yield put(push('/password/new'));
  }
}

export function* resetPassword(action) {
  const response = yield call(api.patch, `v2/customers/password/${action.payload.token}`, {
    customer: { ...action.payload },
  });

  if (response.ok) {
    if (IS_APP) {
      window.ReactNativeWebView.postMessage(JSON.stringify({
        type: 'forgot_password',
        success: true,
        message: 'Sua senha foi alterada com sucesso!',
      }));
    } else {
      yield put(SessionCreators.saveSession(response.data.token));
      window.location.href = '/';
    }
  } else {
    yield put(MessagesCreators.setMessage(formatter(response.data), 'danger'));
  }
}



// WEBPACK FOOTER //
// ./src/store/sagas/resetPassword.js